import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
const CHECKOUT = 'https://dance-pro.impultienda.ar/checkout';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 30;
          seconds = 5;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-6 px-4 sm:px-6 bg-brand-cream border-y-4 border-brand-gold/30 scroll-mt-2" data-id="element-113">
      <div className="text-center mb-3" data-id="element-114">
        <p className="text-xs font-button font-bold text-brand-gold uppercase tracking-widest mb-1" data-id="element-115">
          OFFERTA SPECIALE — PACK COMPLETO 6 IN 1
        </p>
        <p className="text-sm font-bold text-brand-taupe mb-2 leading-tight" data-id="element-116">
          Accedi al sistema ora e trasforma il tuo metodo di insegnamento oggi
          stesso.
        </p>
        <div className="inline-block bg-brand-rose text-white px-3 py-1 rounded shadow-sm mb-3" data-id="element-117">
          <p className="font-button font-bold text-sm tracking-wide" data-id="element-118">
            🩰 DANZA READY™ — Box Set Completo 6 in 1
          </p>
        </div>
        <a href={CHECKOUT} target="_blank" rel="noopener noreferrer" className="block cursor-pointer" data-id="element-119">
          <img src="https://cdn.magicpatterns.com/uploads/6PKu3wnxFsSvqguc9Xmwz5/ChatGPT_Image_10_jul_2026,_09_16_51_p.m..png" alt="Danza Ready - Box Set Completo 6 in 1" className="w-full max-w-[220px] mx-auto object-contain drop-shadow-lg mb-3" data-id="element-120" />
        </a>
      </div>

      <div className="bg-white border-4 border-brand-gold rounded-lg p-4 text-center relative mb-3 shadow-xl" data-id="element-121">
        <div className="mb-3" data-id="element-122">
          <p className="text-sm font-bold text-brand-taupe/70 mb-0.5" data-id="element-123">
            Prezzo Normale: <span className="line-through" data-id="element-124">€97</span>
          </p>
          <p className="text-base font-button font-bold text-red-600 mb-1 uppercase tracking-wide" data-id="element-125">
            🔥 72% DI SCONTO — OFFERTA DI LANCIO
          </p>
          <p className="text-5xl font-heading font-bold text-brand-taupe mb-0.5 leading-none" data-id="element-126">
            €27
          </p>
          <p className="text-[10px] font-bold text-brand-taupe/60 uppercase tracking-wider" data-id="element-127">
            Paga nella tua valuta locale
          </p>
        </div>

        <div className="bg-red-50 border border-red-200 rounded p-2 mb-4" data-id="element-128">
          <p className="text-xs font-bold text-red-600 mb-1.5 uppercase tracking-tight" data-id="element-129">
            🔥 Ultima occasione! Il prezzo aumenta allo scadere del timer.
          </p>
          <div className="flex justify-center gap-2" data-id="element-130">
            <div className="text-center" data-id="element-131">
              <div className="bg-brand-taupe text-white text-xl font-bold px-2 py-1 rounded shadow-inner leading-none" data-id="element-132">
                {String(timeLeft.hours).padStart(2, '0')}
              </div>
              <p className="text-[9px] font-bold text-brand-taupe/70 mt-0.5 tracking-wider" data-id="element-133">
                ORE
              </p>
            </div>
            <div className="text-lg font-bold text-brand-taupe mt-0.5" data-id="element-134">:</div>
            <div className="text-center" data-id="element-135">
              <div className="bg-brand-taupe text-white text-xl font-bold px-2 py-1 rounded shadow-inner leading-none" data-id="element-136">
                {String(timeLeft.minutes).padStart(2, '0')}
              </div>
              <p className="text-[9px] font-bold text-brand-taupe/70 mt-0.5 tracking-wider" data-id="element-137">
                MINUTI
              </p>
            </div>
            <div className="text-lg font-bold text-brand-taupe mt-0.5" data-id="element-138">:</div>
            <div className="text-center" data-id="element-139">
              <div className="bg-brand-taupe text-white text-xl font-bold px-2 py-1 rounded shadow-inner leading-none" data-id="element-140">
                {String(timeLeft.seconds).padStart(2, '0')}
              </div>
              <p className="text-[9px] font-bold text-brand-taupe/70 mt-0.5 tracking-wider" data-id="element-141">
                SECONDI
              </p>
            </div>
          </div>
        </div>

        <CTAButton href={CHECKOUT} data-id="element-142">🚀 SÌ, VOGLIO IL PACK 6 IN 1</CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-1 sm:gap-4 text-xs text-brand-taupe font-bold" data-id="element-143">
        <div className="flex items-center gap-1" data-id="element-144">
          <Star className="w-3.5 h-3.5 fill-brand-gold text-brand-gold" data-id="element-145" />
          <span data-id="element-146">4.9/5 — Recensioni Verificate</span>
        </div>
        <div className="flex items-center gap-1" data-id="element-147">
          <Shield className="w-3.5 h-3.5 text-brand-rose" data-id="element-148" />
          <span data-id="element-149">Garanzia 7 Giorni — Zero Rischio</span>
        </div>
      </div>
    </section>;
}